/**
 */

import { ACTIONS } from '../actions';

const INITIAL_STATE = {
    all: [],
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.FETCH_URLS:
            return { ...state, all: action.payload.data };
        default:
            return state;
    }
}

export function DeletePrivateUrl(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.DELETE_URLS:
            let result = {};
            if(action.payload.status === 200) {
                result = { url: action.payload.data, isError: false };
            } else {
                result = { url: action.payload.response.data, isError: true };
            }
            return { ...state, result };
        default:
            return state;
    }
}

export function UpdatePrivateUrl(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.UPDATE_URLS:
            let result = {};
            if (action.payload.status === 200) {
                result = {url: action.payload.data, isError: false};
            } else {
                result = {url: action.payload.response.data, isError: true};
            }
            return {...state, result};
        default:
            return state;

    }
}

const INIT_CUSTOM_URL = {
  isError: false,
  url: {}
};
export function CustomPrivateUrl(state = INIT_CUSTOM_URL, action) {
    switch (action.type) {
        case ACTIONS.CUSTOM_PRIVATE_URL:
            if (action.payload.status === 200) {
                return {...state, url: action.payload.data, isError: false};
            } else {
                return {...state, url: action.payload.response.data, isError: true};
            }
        default:
            return state;
    }
}

const INITIAL_STATE_PROTECT_FILE = {
    response: false
};

export function ProtectFile(state = INITIAL_STATE_PROTECT_FILE, action) {
    switch (action.type) {
        case ACTIONS.PROTECT_FILE:
            if (action.payload.status === 200) {
                return { ...state, response: action.payload.data };
            } else {
                return { ...state, response: action.payload.response.data.message, error: true }
            }
        default:
            return state;
    }
}

const STATE_PROTECTED_FILE = {
    is_protected: false,
    post: null
};

export function IsProtectedFile(state = STATE_PROTECTED_FILE, action) {
    switch (action.type) {
        case ACTIONS.IS_PROTECTED_FILE:
            if (action.payload.status === 200) {
                return { ...state, is_protected: action.payload.data.is_protected, post: action.payload.data.post, role_setting: action.payload.data.role_setting };
            } else {
                return { ...state, is_protected: false, post: null, role_setting: null, error: true}
            }
        default:
            return state;
    }
}

const STATE_PRIVATE_LINK_USER = {
    data_private_link: [],
};

export function PrivateLinkUser(state = STATE_PRIVATE_LINK_USER, action) {
    switch (action.type) {
        case ACTIONS.GET_URL_FOR_USER:
            if (action.payload.status === 200) {
                return { ...state, data_private_link: action.payload.data };
            } else {
                return { ...state, data_private_link: false }
            }
        default:
            return state;
    }
}
